import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { DevelopUtil } from '../../utils/develop.utils';
import { StorageUtil } from '../../utils/storage.util';
import { AUTHORIZATION_KEY } from '../../consts/auth';

@Injectable()
export class AuthentificationService {

  public static LOGIN_URL = 'api/login';
  public static SIGNIN_URL = 'api/signin';
  public static USERS_URL = 'api/users';
  public static AUTH_USERS_URL = 'api/auth';
  public static LOGGEDIN_URL = 'api/loggedin';
  public static LOGOUT_URL = 'api/logout';


  public token: string;

  private headers: Headers;
  private requestOptions: RequestOptions;

  public static saveToken(token: string): boolean {
    localStorage.setItem(AUTHORIZATION_KEY, token);
    return true;
  }

  constructor(private http: Http) {
    this.requestOptions = new RequestOptions({headers: this.headers, withCredentials: true});
  }

  login(username, password): Observable<Response> {
    return this.http.post(AuthentificationService.LOGIN_URL, {
      'username': username,
      'password': password
    });
  }

  getUsers(): Observable<Response> {
    return this.http.get(AuthentificationService.USERS_URL, this.requestOptions);
  }

  authForUser(profileId: any): Observable<Response> {
    return this.http.post(AuthentificationService.AUTH_USERS_URL, {profile: profileId});
  }

  signIn(): Observable<Response> {
    return this.http.get(AuthentificationService.SIGNIN_URL, this.requestOptions);
  }

  loggedIn() {
    return StorageUtil.getToken();
  }


  getCookies(): Observable<Response>  {
     return this.http.get(AuthentificationService.LOGGEDIN_URL, this.requestOptions);
  }

  logout(): Observable<Response> {
    StorageUtil.clear();
    return this.http.get(AuthentificationService.LOGOUT_URL, this.requestOptions);
  }


}


// WEBPACK FOOTER //
// ./src/app/services/auth/authentification.service.ts